// Module
var code = "<a class=\"br-link-1 text-ellipsis\" ng-click=\"$event.stopPropagation();\" ui-sref=\"billing-account.orders({ billingAccountId: $ctrl.id })\"> {{$ctrl.name}} <md-tooltip md-delay=\"300\" md-direction=\"top\" class=\"bringoz-tooltip\"> {{$ctrl.name}} </md-tooltip> </a> ";
// Exports
export default code;